import { useEffect, useState } from 'react';
import getDeviceFingerprint from '../../../../../utils/fingerprint';

/**
 * Custom hook to manage device fingerprint
 * Generates and caches the fingerprint for the current session
 */
export function useFingerprint() {
  const [fingerprint, setFingerprint] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const fp = getDeviceFingerprint();
      setFingerprint(fp);
    } catch (error) {
      console.error('[Fingerprint] Failed to generate fingerprint:', error);
      setFingerprint(null);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    fingerprint,
    loading,
  };
}

